const types = {
    GET_MENU: 'GET_MENU',
    STORE_MENU: 'STORE_MENU',
    CLEAR_MENU: 'CLEAR_MENU',
    SET_ACTIVE_MENU: 'SET_ACTIVE_MENU'
}

export default types;

export const getMenu = (username) => {
    return { type: types.GET_MENU, payload: { username } };
}

export const storeMenu = (menuNavigation) => {
    return { type: types.STORE_MENU, payload: menuNavigation };
}

export const clearMenu = () => {
    return { type: types.CLEAR_MENU };
}

export const setActiveMenu = (name, icon, to) => {
    return { type: types.SET_ACTIVE_MENU, payload: { name, icon, to } };
}